import { AssetLockedModal, useIsDemoLocked } from '@carboncopyco/components';
import { useGetCurrentUserQuery } from '@carboncopyco/data';
import { useEditorTools } from '@carboncopyco/editor-sdk';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { HOME_TAB_ID } from '../../services/TabManager';
import { useTabs } from '../../store/context';
import ModalWrapper from '../Modals/ModalWrapper';

export const DemoLockedModal = ({
  tab,
  demoId,
  organizationId,
  onExit,
}: {
  tab: IGlobalTab;
  demoId: number;
  organizationId: string;
  onExit: () => void;
}) => {
  const { trackEvent } = useAnalytics();
  const { activeGlobalTab, setActiveGlobalTabId } = useTabs();
  const isTabActive = activeGlobalTab.id === tab.id;

  const {
    isOpen: isOpenModal,
    close: closeModal,
    open: openModal,
  } = useEditorTools();

  const { data: userData } = useGetCurrentUserQuery();

  const currentUserEmail = userData?.user?.email;

  const { userName } = useIsDemoLocked({
    demoId: String(demoId),
    organizationId,
    currentUserEmail: currentUserEmail || '',
    onDemoLock: (lockedBy) => {
      openModal('demoLocked');

      trackEvent(AnalyticsTrackEventName.DEMO_MULTI_USER_LOCK, {
        variables: {
          userEditing: lockedBy,
          userTryingToEdit: currentUserEmail,
        },
        demoId,
      });
    },
    shouldRunInterval: isTabActive,
  });

  const isDemoLockedModalOpen =
    isOpenModal('demoLocked') &&
    demoId === Number(activeGlobalTab?.payload?.demo?.id);

  return (
    <ModalWrapper isVisible={isDemoLockedModalOpen}>
      <AssetLockedModal
        userName={userName}
        onButtonClick={() => {
          closeModal('demoLocked');
          onExit();
          setActiveGlobalTabId(HOME_TAB_ID);
        }}
        buttonLabel="Go to overview"
      />
    </ModalWrapper>
  );
};
